import InputContainerC from '../controls/InputContainer';
import LabelContainer from '../controls/LabelContainer';
import DropDownContainerC from '../controls/DropDownContainer';
import MultiSelectContainer from '../controls/MultiSelectContainer';
import RadioContainerC from '../controls/RadioContainer';
import GoogleAddressSearchContainer from '../controls/GoogleAddressSearchContainer';
import AdditionalFormSelector from '../../../../utils/formList';
import MultipleCheckBoxC from '../../../../utils/MultipleCheckBoxC';
import CheckBoxes from '../../../../utils/CheckBoxes';

// use this object to map inputTypes to components
const maps = {
    text: InputContainerC,
    freeform: InputContainerC,
    label: LabelContainer,
    number: InputContainerC,
    password: InputContainerC,
    'dropdown-single': DropDownContainerC,
    'dropdown-multi': MultiSelectContainer,
    radio: RadioContainerC,
    'googleSearch': GoogleAddressSearchContainer,
    'dropdown-multiselect': AdditionalFormSelector,
    'dropdown-multiselectcheckbox': MultipleCheckBoxC,
    'checkbox': CheckBoxes,
};

export default maps;
